import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CampaignComponent } from './components/campaign/campaign.component';
import { PreviewComponent } from './components/campaign/preview/preview.component';

const routes: Routes = [
  {
    path: ':id',
    component: CampaignComponent,
    data: {
      title: 'Start New Campaign',
      page_name: 'start_a_fundraiser',
      category: 'start fundraiser',
      lastOrderSkip: true
    }
  },
  {
    path: 'preview/:id',
    component: PreviewComponent,
    data: {
      title: 'Campaign Preview',
      page_name: 'fundraiser_preview',
      category: 'crowdfunding',
      lastOrderSkip: true
    }
  },
  {
    path: '**',
    redirectTo: 'basic'
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CampaignRoutingModule { }
